/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface DiplomeCertificationIfapmeFichierUploadDto
 */
export interface DiplomeCertificationIfapmeFichierUploadDto {
    /**
     * 
     * @type {FileUploadDto}
     * @memberof DiplomeCertificationIfapmeFichierUploadDto
     */
    file?: FileUploadDto;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationIfapmeFichierUploadDto
     */
    iddiplomeCertificationIfapmeFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationIfapmeFichierUploadDto
     */
    iddiplomeCertificationIfapme?: number;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationIfapmeFichierUploadDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationIfapmeFichierUploadDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof DiplomeCertificationIfapmeFichierUploadDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the DiplomeCertificationIfapmeFichierUploadDto interface.
 */
export function instanceOfDiplomeCertificationIfapmeFichierUploadDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DiplomeCertificationIfapmeFichierUploadDtoFromJSON(json: any): DiplomeCertificationIfapmeFichierUploadDto {
    return DiplomeCertificationIfapmeFichierUploadDtoFromJSONTyped(json, false);
}

export function DiplomeCertificationIfapmeFichierUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiplomeCertificationIfapmeFichierUploadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : FileUploadDtoFromJSON(json['file']),
        'iddiplomeCertificationIfapmeFichier': !exists(json, 'iddiplomeCertificationIfapmeFichier') ? undefined : json['iddiplomeCertificationIfapmeFichier'],
        'iddiplomeCertificationIfapme': !exists(json, 'iddiplomeCertificationIfapme') ? undefined : json['iddiplomeCertificationIfapme'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function DiplomeCertificationIfapmeFichierUploadDtoToJSON(value?: DiplomeCertificationIfapmeFichierUploadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': FileUploadDtoToJSON(value.file),
        'iddiplomeCertificationIfapmeFichier': value.iddiplomeCertificationIfapmeFichier,
        'iddiplomeCertificationIfapme': value.iddiplomeCertificationIfapme,
        'idfichier': value.idfichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'fileName': value.fileName,
    };
}

